import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'
import { MenuCategoryStatusSchema } from '~/services/api/generated'

export const menuCategoryFieldsNormalizer = fieldNormalizer({
  trimmed: ['name'],
  blankToNull: ['description'],
  enums: [{ field: 'status', options: MenuCategoryStatusSchema.options }]
})
